import React from 'react';
import { inputStyles } from '../../styles/tailwind.classes';

const Input = ({ 
  error, 
  disabled, 
  className = '', 
  ...props 
}) => {
  const baseClasses = inputStyles.base;
  const stateClasses = error 
    ? inputStyles.error 
    : disabled 
    ? inputStyles.disabled 
    : inputStyles.default;

  return (
    <input
      className={`${baseClasses} ${stateClasses} ${className}`}
      disabled={disabled}
      {...props}
    />
  );
};

export default Input; 